module.exports = __webpack_public_path__ + "static/media/fullscreen.7fa92dfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/organisms/KidsTour/fullscreen.svg
// module id = 926
// module chunks = 0